/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalDocumentExtraction } from './PalDocumentExtraction';
import {
    PalDocumentExtractionFromJSON,
    PalDocumentExtractionFromJSONTyped,
    PalDocumentExtractionToJSON,
} from './PalDocumentExtraction';

/**
 * 
 * @export
 * @interface CreatePalDocumentExtraction201Response
 */
export interface CreatePalDocumentExtraction201Response {
    /**
     * 
     * @type {PalDocumentExtraction}
     * @memberof CreatePalDocumentExtraction201Response
     */
    data?: PalDocumentExtraction;
}

/**
 * Check if a given object implements the CreatePalDocumentExtraction201Response interface.
 */
export function instanceOfCreatePalDocumentExtraction201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePalDocumentExtraction201ResponseFromJSON(json: any): CreatePalDocumentExtraction201Response {
    return CreatePalDocumentExtraction201ResponseFromJSONTyped(json, false);
}

export function CreatePalDocumentExtraction201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalDocumentExtraction201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalDocumentExtractionFromJSON(json['data']),
    };
}

export function CreatePalDocumentExtraction201ResponseToJSON(value?: CreatePalDocumentExtraction201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalDocumentExtractionToJSON(value.data),
    };
}

